import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ModalRichTextAlert",
    component: () => require("./modal-rich-text-alert-view")
});

export default definition;
